import axios from '../utils/setupAxiosAuth';
import { getAdminApiBaseUrl } from '../utils/adminApiBaseUrl';
import { getAuthHeaders } from '../utils/authHeaders';

export type AppDownloadPeriod = 'daily' | 'weekly' | 'monthly' | 'quarterly';

export type AppDownloadTrendRow = {
  period: string;
  period_start: string;
  android_downloads: number;
  ios_downloads: number;
  total_downloads: number;
  active_device_installs?: number;
  daily_user_uninstalls?: number;
  daily_crashes?: number;
  daily_anrs?: number;
  daily_avg_rating?: number | null;
  store_listing_visitors?: number;
  store_listing_acquisitions?: number;
  store_listing_conversion_rate?: number | null;
  crash_rate?: number | null;
  anr_rate?: number | null;
};

export type AppDownloadSyncState = {
  status: string;
  last_started_at?: string | null;
  last_completed_at?: string | null;
  rows_upserted?: number;
  android_status?: string | null;
  ios_status?: string | null;
  message?: string | null;
};

export type AppDownloadTotals = {
  android_downloads: number;
  ios_downloads: number;
  total_downloads: number;
  active_device_installs?: number;
  daily_user_uninstalls?: number;
  daily_crashes?: number;
  daily_anrs?: number;
  daily_avg_rating?: number | null;
  store_listing_visitors?: number;
  store_listing_acquisitions?: number;
  store_listing_conversion_rate?: number | null;
  crash_rate?: number | null;
  anr_rate?: number | null;
};

export type AppDownloadTable = {
  rows: AppDownloadTrendRow[];
  total: number;
  offset: number;
  limit: number;
};

export type AppDownloadResponse = {
  totals: AppDownloadTotals;
  trend: AppDownloadTrendRow[];
  table: AppDownloadTable;
  sync?: AppDownloadSyncState | null;
};

const apiBase = () => getAdminApiBaseUrl().replace(/\/?$/, '/');

export const fetchAppDownloads = async (
  fromDate: string,
  toDate: string,
  period: AppDownloadPeriod,
  tableOffset = 0,
  tableLimit = 30
): Promise<AppDownloadResponse> => {
  const response = await axios.get(`${apiBase()}customers/app-downloads`, {
    params: {
      from_date: fromDate,
      to_date: toDate,
      period,
      table_offset: tableOffset,
      table_limit: tableLimit,
    },
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const syncAppDownloads = async (
  fromDate: string,
  toDate: string
): Promise<unknown> => {
  const response = await axios.post(
    `${apiBase()}customers/app-downloads/sync`,
    { from_date: fromDate, to_date: toDate },
    { headers: getAuthHeaders() }
  );
  return response.data;
};
